/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react'
import {monthNames} from '../../../../utils/commonFunctions';
import CustomSelect from '../../../../common/CustomSelect.jsx';
import HorizontalBarChart from '../../../../common/BarHorizondal'
import {NGODatePicker} from '../../../../common';
const BarData = {
    salesLeft:{
        data:[-20,40, -40.13,20],
        labels:[ 'DOMLUX', 'MERCHANDISE', 'NON-PERISHABLE',"PERISHABLE"]
    },
    qtyLeft:{
        data:[ 0,-3, -4,-3],
        labels:['DOMLUX', 'MERCHANDISE', 'NON-PERISHABLE',"PERISHABLE"]
    },
    salesRight:{
        data:[42.5],
        labels:['LGK-SIN|SIN-LGK', '', '', '',""]
    },
    qtyRight:{
        data:[0],
        labels:['LGK-SIN|SIN-LGK', '', '', '',""]
    }
}


const IrTopCards = ({chartData,chartData2}) => {
  const [data, setData] = useState(BarData);
  const [monthChange, setMonthChange] = useState(null);
  const [state, setState] = useState({fromDate:null,toDate:null});


  const onChangeInputFromDate=(e)=>{
    setState((_)=>({..._,fromDate:e.target.value}));
   }
     const onChangeInputToDate=(e)=>{
    setState((_)=>({..._,toDate:e.target.value}));
   }
const onMonthChange=(e)=>{
setMonthChange(e);
setState({fromDate:null,toDate:null});
}

  useEffect(() => {
    if(Object.keys(chartData).length === 0 || chartData2.length === 0) return;
    setData(prev=>{
      return {
        ...prev,
        qtyLeft:{data:[...Object.keys(chartData).map(key=>chartData[key]?.varianceCount)],labels:[...Object.keys(chartData)]},
        salesLeft:{data:[...Object.keys(chartData).map(key=>chartData[key]?.varienceValue)],labels:[...Object.keys(chartData)]},
        qtyRight:{
          labels:[...chartData2.map(data=>data.sector)],
          data:[...chartData2.map(data=>data.varianceData.varianceCount)]
        },
        salesRight:{
          labels:[...chartData2.map(data=>data.sector)],
          data:[...chartData2.map(data=>data.varianceData.varienceValue)]
        }
      }
    })
  }, [chartData,chartData2])

  return (<>
  <div className='flexRow justifyContentSpaceBetween'>

  <div className='width50 flexRow justifyContentSpaceBetween'>
     <div className='margTop8 flexRow justifyContentFlexStart'><h6>Sales variance by product category</h6></div>
         <CustomSelect
             onChange={onMonthChange}
             options={monthNames.map((item,index)=>({key:index,label:item,value:item}))}
             placeHolder={"Month"}
             isClearable={false}
             width={"8rem"}
             value={monthChange?monthNames?.map(function (option,ind) {
              return (
               option === monthChange.label?{key:ind,label:option,value:option}:null
              );
            }).filter(fl=>fl!==null):[{key:0,label:monthNames[new Date().getMonth()],value:monthNames[new Date().getMonth()]}]}
            />
               <div className='flexRow'>

                 <NGODatePicker
                value={state.fromDate}
                 selectsStart={true}
                 style={{border:'0.7px solid #fff',marginTop:0,borderRadius:'4px',height:'0.5rem',width:'7rem'}}
                 dateFormat="dd/MM/yyy"
                 name='fromDate'
                 placeholder={'Select From Date'}
                 className='margRight'
                 isClearable={true}
                onChange={onChangeInputFromDate}
                 />
                 </div>

                 <div className='flexRow margRight15'>


                 <NGODatePicker
                value={state.toDate}
                 selectsEnd={true}
                style={{border:'0.7px solid #fff',marginTop:0,borderRadius:'4px',height:'0.5rem',width:'6rem'}}
                 placeholder={'Select To Date'}
                 dateFormat="dd/MM/yyy"
                 name='toDate'
                 className=''
                 isClearable={true}
                 onChange={onChangeInputToDate}
                 />
                 </div>

  </div>

     <div className='width50 flexRow justifyContentSpaceBetween'>

     <div className='margTop8 flexRow justifyContentFlexStart'><h6>Top 10 Sales Variance by sector pairing</h6></div>
       <CustomSelect
             onChange={onMonthChange}
             options={monthNames.map((item,index)=>({key:index,label:item,value:item}))}
             placeHolder={"Month"}
             isClearable={false}
             width={"8rem"}
             value={monthChange?monthNames?.map(function (option,ind) {
              return (
               option === monthChange.label?{key:ind,label:option,value:option}:null
              );
            }).filter(fl=>fl!==null):[{key:0,label:monthNames[new Date().getMonth()],value:monthNames[new Date().getMonth()]} ]}
            />
               <div className='flexRow'>

                 <NGODatePicker
                value={state.fromDate}
                 selectsStart={true}
                 style={{border:'0.7px solid #fff',marginTop:0,borderRadius:'4px',height:'0.5rem',width:'7rem'}}
                 dateFormat="dd/MM/yyy"
                 name='fromDate'
                 placeholder={'Select From Date'}
                 className='margRight'
                 isClearable={true}
                onChange={onChangeInputFromDate}
                 />
                 </div>

                 <div className='flexRow margRight11'>


                 <NGODatePicker
                value={state.toDate}
                 selectsEnd={true}
                style={{border:'0.7px solid #fff',marginTop:0,borderRadius:'4px',height:'0.5rem',width:'6rem'}}
                 placeholder={'Select To Date'}
                 dateFormat="dd/MM/yyy"
                 name='toDate'
                 className=''
                 isClearable={true}
                 onChange={onChangeInputToDate}
                 />
                 </div>
</div>
  </div>

    <div className='IrTopCardsWrapper'>
        <div className='IrTopCard'>
        <div className='IrTopCardInner'>
        <div className='canvasWrapper'>
          <div className='canvasWrapper__inner'>
            <div
              className='canvasTitle'
            >
              <p>Sales Variance</p>
            </div>
            <HorizontalBarChart dataS={data.salesLeft.data} labels={data.salesLeft.labels} />
          </div>
          <div className='canvasWrapper__inner'>
            <div className='canvasTitle'>
              <p>Quantity Variance</p>
            </div>
            <HorizontalBarChart displayLabel={false} showCurrency={false} dataS={data.qtyLeft.data} labels={data.qtyLeft.labels} />
          </div>
        </div>

        </div>
      </div>

      <div className='IrTopCard'>
        <div style={{border:"1px solid #fff",padding:"0.5rem",borderRadius:10,height:"100%"}}>
        <div style={{ display: "flex" }}>
          <div className='canvasWrapper__inner'>
            <div className='canvasTitle'>
              <p>Sales Variance</p>
            </div>
            <HorizontalBarChart dataS={data.salesRight.data} labels={data.salesRight.labels} />
          </div>
          <div
            className='canvasWrapper__inner'
          >
            <div className='canvasTitle'>
              <p>Quantity Variance</p>
            </div>
            <HorizontalBarChart showCurrency={false} displayLabel={false} dataS={data.qtyRight.data} labels={data.qtyRight.labels} />
          </div>
        </div>
        </div>
      </div>
        </div>
  </>
  )
}

export default IrTopCards